/*
 * Responsive Tables in RichText Field
 **/

const enableResponsiveTableWithin = targetDOM => {
	// Make sure target DOM exists.
	if (!targetDOM) {
		return
	}
	// Helper to do forEach with root as scope.
	const forEach = (selector, callback, root = null) => {
		if (!root) {
			root = targetDOM
		}
		Array.prototype.forEach.call(root.querySelectorAll(selector), callback)
	}

	forEach("table", table => {
		const headings = []
		forEach(
			"thead > tr > th",
			(th, index) => {
				const thText = th.innerText
				headings.push(thText)
			},
			table
		)
		// If table doesn't have thead then abort
		if (!headings.length) {
			return
		}

		// If the number of td is not multiple of number of heading, it's likely to be colspan, abort!
		const numberOfHeadings = headings.length
		const numberOfTds = table.querySelectorAll("tbody > tr > td").length
		if (numberOfTds % numberOfHeadings) {
			return
		}

		table.classList.add("table")

		forEach(
			"tbody > tr > td",
			(td, index) => {
				let heading = headings[index % numberOfHeadings]
				td.setAttribute("data-th", heading)
			},
			table
		)
	})
}

// Targetting all tables within richtext
Array.prototype.forEach.call(
	document.querySelectorAll(".richtext"),
	richText => {
		enableResponsiveTableWithin(richText)
	}
)
